fragment OrderItemProductVariationAttachmentFragment on OrderItemProductVariationAttachment {

    id

    order_item_product_variation_id
    attachment_variation_id

    attachmentVariation {
        ...AttachmentVariationFragment
    }

    attachment_number
    attachment_title

    attachment_variation_number
    attachment_variation_name
    attachment_variation_description

    pcs_price
    total_price

    discount

    created_at
    updated_at

}